<template>
<div :class="$style['select-client-dialog']" v-if="dialogVisible">
    <el-dialog :visible="dialogVisible" title="" @close="cancel">
        <ptCustomerManage :hideBtn="true" :canEdit="canEdit" title="" :showRadio="true" @updateSelectData="updateSelectData" :selectedKeys="selectedKeys"></ptCustomerManage>
        <div class="button-div">
          <el-button type="primary" @click="submit">选择</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
</div>
</template>
<script>
import ptCustomerManage from 'cps/customer-manage/pt-customer-manage/index'
import { customerTableLabels } from 'cps/customer-manage/pt-customer-manage/options.js'
export default {
  name: 'default-package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: '选择委托方'
    },
    pageSize: {
      type: Number,
      default: 8
    },
    // 传进的id // 用于回显
    selectedKeys: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  components:{ptCustomerManage},
  computed: {
    tableLabels () {
      return customerTableLabels
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      page: 0,
      select_row: null,
      isContractFunction: null
    }
  },
  watch: {
    agentId (val) {
      this.getTableData(0)
    },
  },
  methods: {
    updateSelectData (data) {
      this.select_row = data
    },
    submit () {
      if(this.selectedKeys && !this.select_row){
        this.cancel()
        return
      }
      this.$emit('selectData', this.select_row)
    },
    cancel () {
      this.$emit('close')
    },
    goDetail (row) {
      this.$router.push(`/customer-detail/${row.id}`)
    },
    getTableData (page, next) {
      let data = {
        example:{
          ...this.paramsData,
        },
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getOrganizationsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '获取客户列表失败')
      })
    },
  }
}
</script>
<style module lang="less">
@import "~less/var";
.select-client-dialog{
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
     :global
    .el-radio__label{
        display: none;
    }
     :global
    .el-pagination .el-select .el-input .el-input__inner{
      min-width:auto;
    }
    :global
    .el-radio__inner{
        border:1px solid #409eff;
        border-radius:50%
    }
}
</style>
